module.exports = __webpack_public_path__ + "static/media/download.63a0a91e.svg";